<script lang="ts" setup>
  import { CartLayout, CartWithSummaryLayout } from '@storefront/components';

  defineOptions({
    layout: [CartLayout, CartWithSummaryLayout],
    inheritAttrs: false,
  });
</script>
<template>
  <FormController v-slot="{ processing, submit }" :action="$route('web.cart.purchase.store')" method="POST">
    <div class="warning">
      <p class="warning-title">{{ $t('SHOP.CART.HEADER.CHECK_ORDER_DATA') }}</p>
      <p class="warning-content">{{ $t('SHOP.CART.MESSAGE.CHECK_ORDER_DATA') }}</p>
    </div>
    <UiButtonGroup>
      <SfButton :loading="processing" large primary @click="submit">
        <template #before>
          <SfIconWallet aria-hidden="true" />
        </template>
        <template #default>
          {{ $t('SHOP.CART.ACTION.ORDER_AND_PAY') }}
        </template>
      </SfButton>
    </UiButtonGroup>
  </FormController>

  <RouterView />
</template>
<style lang="scss">
  .warning {
    font-size: 0.875rem;
    color: var(--secondary-color);

    .warning-title {
      font-weight: var(--font-weight-bold);
      color: var(--color-default);
    }
  }
</style>
